function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M58.243 34.91H22.855v66.844h35.388V34.91z",
  fill: "#EFC91E"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M106.921 34.91H58.119v66.844h48.802V34.91z",
  fill: "#FFCE32"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.921 34.91v23.674h22.496L106.921 34.91z",
  fill: "#D2B982"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#002F34"
}, /*#__PURE__*/React.createElement("path", {
  d: "M73.064 53.441a9.163 9.163 0 100 18.327 9.163 9.163 0 000-18.327zm0 11.912a2.752 2.752 0 01-2.749-2.749 2.752 2.752 0 012.749-2.749 2.752 2.752 0 012.749 2.75 2.752 2.752 0 01-2.749 2.748zM92.815 59.05l-1.943-1.944h-2.537v2.537l1.943 1.943-1.943 1.942v2.537h2.537l1.943-1.942 1.943 1.942h2.537v-2.537l-1.943-1.942 1.943-1.943v-2.537h-2.537l-1.943 1.943zM84.522 77.065c-.12-.002-.238-.004-.357-.004-5.344 0-10.516 2.558-15.376 7.61l2.615 2.57c4.223-4.388 8.603-6.567 13.005-6.492 6.432.12 10.94 5.08 10.985 5.13l1.332-1.21 1.384-1.25c-.223-.252-5.556-6.182-13.588-6.354z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.855 34.857l-.047.102L.359 58.584h34.156l23.728-23.727H22.855z",
  fill: "#D2B982"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M37.744 14.041l-2.961 5.1 13.283 7.713 2.961-5.1-13.283-7.713zM65.753.552l-5.843.8 2.142 15.64 5.843-.8L65.753.552zM89.508 11.484l-11.783 9.212 3.632 4.646 11.784-9.211-3.633-4.647z",
  fill: "#FFCE32"
});

const SvgPackageWithIssue = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 130,
  height: 102,
  fill: "none"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);

export default SvgPackageWithIssue;